





























































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Emit } from 'vue-property-decorator';
import dayjs from 'dayjs';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import ProfileRatingStar from '@/components/profile/profileParts/ProfileRatingStar.vue';
import ProfileEvaluationCard from '@/components/profile/profileParts/ProfileEvaluationCard.vue';
import ProfileEditBasic from '@/components/profile/profileEditList/ProfileEditBasic.vue';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { vxm } from '@/store';
import {
  Account,
  AccountRetentionSkill,
  FindOneAccountQuery,
  AccountRetentionQualification,
  UpdateAccountRetentionSkillParam,
  UpdateAccountRetentionQualificationParam,
  UpdateAccountSelfIntroductionParam,
  UpdateAccountBasicParam,
  UpdateAccountBasicQuery,
  UpdateAccountParticipationConditionParam,
  UpdateAccountParticipationConditionQuery,
} from '@/@types/Account';
import { UploadFileFieldName } from '@/@types/Common';
import {
  Gender,
  Occupation,
  PaymentUnitDivision,
  Qualification,
  Skill,
} from '@/@types/masterData';

@Component({
  components: {
    CommonModalHeader,
    AccountIcon,
    CommonButton,
    ProfileRatingStar,
    ProfileEvaluationCard,
    ProfileEditBasic
  },
})
export default class ProfileEdit extends Vue {
  private accountsRepository = RepositoryFactory.theoryApi.accountsRepository();
  private isOpenUpdateHeaderPhotoModal: boolean = false;
  private isOpenAddSkillCard: boolean = false;
  private accountName: string = '';
  private modalHeaderTitle: string = '画像位置を選択してください';
  private modalMode: string = 'add';
  private isPublic: boolean = true;
  private isPublicScout: boolean = true;
  private tab = null;
  private jobName: string | null = '';
  private skillName: string = '';
  private qualificationName: string = '';
  private searchJobWord: string = '';
  private searchSkillWord: string = '';
  private searchQualificationWord: string = '';
  private isDisplayEditIcon: boolean = false;
  private detailFlag = true;
  private headerImage: string | null = '';
  private age: string | null = null;
  private gender: string | null = null;
  private birthday: string | null = null;
  private perfectures: string | null = null;
  private city: string | null = null;
  private streetAddress: string | null = null;
  private phoneNumber: string | null = null;
  private place: string | null = null;
  private desiredPayment: string | null = null;
  private desiredPaymentUnit: string | null = null;
  private scheduleUptime: string | null = null;
  private nearStation: string | null = null;
  private retentionSkills: AccountRetentionSkill[] = [];
  private selectedSkillName: string = '';
  private skillYearsOfExperience: string = '';
  private retentionQualifications: AccountRetentionQualification[] = [];
  private selectedQualificationName: string = '';
  private qualificationScore: string = '';
  private selfIntroduction: string | null = '';
  private remoteFlag: boolean | null = null;
  private onsiteFlag: boolean | null = null;
  private yearsOfExperience: string | null = null;
  private participationAvailableDate: string | null = null;
  private participationNowAvailable: boolean | null = null;
  private accountLoading: boolean = true;
  private mainWork: string = '';
  private workType = {
    remote: 'リモート',
    onsite: 'オンサイト',
  } as const;

  private rules = {
    required: (value: string) => !!value || '必ず入力してください。',
    number: (value: string) => {
      const regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
      if (value.length > 0 && !regexp.test(value)) {
        return '数値を入力してください。';
      }
      return true;
    },
    score: (value: string) => {
      if (value.length > 0 && value.length > 3) {
        return '３桁以内で入力してください。';
      }
      return true;
    },
    payment: (value: string) => {
      if (value.length > 0 && (value.length < 3 || value.length > 8)) {
        return '３～８桁で入力してください。';
      }
      return true;
    },
    uptime: (value: string) => {
      if (value.length > 0 && value.length > 3) {
        return '３桁以内で入力してください。';
      }
      return true;
    },
    station: (value: string) => {
      if (value.length > 0 && value.length > 20) {
        return '２０文字以内で入力してください。';
      }
      return true;
    },
    years: (value: string) => {
      if (value.length > 0 && value.length > 2) {
        return '２桁以内で入力してください。';
      }
      return true;
    },
    zipcode: (value: string) => {
      if (value.length > 0 && value.length != 7) {
        return '７桁で入力してください。';
      }
      return true;
    },
    address: (value: string) => {
      if (value.length > 0 && value.length > 100) {
        return '１００文字以内で入力してください。';
      }
      return true;
    },
    phoneNumber: (value: string) => {
      if (value.length > 0 && value.length > 11) {
        return '１１桁以内で入力してください。';
      }
      return true;
    },
    date: (value: string) => {
      if (value.length > 0 && value.length != 8) {
        return '８桁で入力してください。';
      }
      return true;
    },
  };
  private isJoinnable: boolean = true;
  private isResumeFileUploaded: boolean = false;
  private resumeFileName: string = '';
  private isOpenConfirmDialog: boolean = false;

  //TODO: まだマスタが無いため、有効な値を送るためにCDを直接記述(井上)
  // テストデータ
  private skills: Skill[] = vxm.theoryApi.mastersStore.getSkill ?? [];
  private qualifications: Qualification[] =
    vxm.theoryApi.mastersStore.getQualification ?? [];
  private occupations: Occupation[] = vxm.theoryApi.mastersStore.getOccupation ?? [];
  private genders: Gender[] = vxm.theoryApi.mastersStore.getGender ?? [];
  private paymentUnitDivisions: PaymentUnitDivision[] =
    vxm.theoryApi.mastersStore.getPaymentUnitDivision ?? [];
  private mainWorks = ['リモート', 'オンサイト', 'どちらでも可'];
  /** プロフィール画面生成前に必要な情報を取得 */
  private async created() {
    await vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId);
    const account = this.account;
    if (account) {
      this.accountName = account.accountName;
      this.headerImage = account.headerImage;
      this.jobName = account.occupationCd;
      this.age = String(account.age);
      this.selfIntroduction = account.selfIntroduction;
      this.birthday = account.birthday
        ? dayjs(account.birthday).format('YYYYMMDD')
        : account.birthday;
      this.streetAddress = account.streetAddress;
      this.gender = account.genderCd;
      this.phoneNumber = account.phoneNumber;
      this.place = account.place;
      this.isPublicScout = account.scoutOpenFlag;
      this.desiredPayment = String(account.desiredPayment);
      this.desiredPaymentUnit = account.desiredPaymentUnitCd;
      this.scheduleUptime = String(account.scheduleUptime);
      this.nearStation = account.nearStation;
      this.remoteFlag = account.remoteFlag;
      this.onsiteFlag = account.onsiteFlag;
      if (this.remoteFlag === null && this.onsiteFlag === null) {
        this.mainWork = 'どちらでも可';
      }
      this.yearsOfExperience = String(account.yearsOfExperience);
      this.participationAvailableDate = account.participationAvailableDate
        ? dayjs(account.participationAvailableDate).format('YYYYMMDD')
        : account?.participationAvailableDate;
      this.participationNowAvailable = account.participationNowAvailable;
      this.mainWork = this.getMainWork();
      this.retentionSkills = account.retentionSkills;
      this.retentionQualifications = account.retentionQualifications;
      this.accountLoading = false;
    }
  }

  // ヘッダー画像選択処理
  private openHeaderExplorer(): void {
    const headerExplorer = this.$refs.headerExplorer;
    headerExplorer.$refs.input.click();
  }

  private async uploadHeaderImage(file: string | Blob | undefined): Promise<void> {
    if (file) {
      const formData = new FormData();
      formData.append(UploadFileFieldName.accountHeader, file);
      const query = {
        'update-mode': 'header',
      };
      await this.accountsRepository.updateAccountImage(
        this.accountId,
        formData,
        query
      );
    }
  }

  private openAvatarExplorer(): void {
    const avatarExplorer = this.$refs.avatarExplorer;
    avatarExplorer.$refs.input.click();
  }

  private async uploadAvatarImage(file: string | Blob | undefined): Promise<void> {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append(UploadFileFieldName.accountIcon, file);
    const query = {
      'update-mode': 'icon',
    };
    await this.accountsRepository.updateAccountImage(
      this.accountId,
      formData,
      query
    );
  }

  // 職務経歴書選択処理
  private openResumeExplorer(): void {
    const resumeFileInput = this.$refs.resumeFileInput as HTMLElement;
    resumeFileInput.click();
  }

  private readResumeFile(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (loadEvent) => {
      // TODO:バックエンド実装後に、データとのbindを行う
    };
    reader.readAsDataURL(files![0]);
    this.isResumeFileUploaded = true;
    this.resumeFileName = files!.item(0)!.name;
    this.isOpenConfirmDialog = false;
  }
  private deleteResumeFile(): void {
    this.isResumeFileUploaded = false;
    this.resumeFileName = '';
  }

  private addSkill() {
    this.isOpenAddSkillCard = true;
  }

  private closeInvitation() {
    this.isOpenAddSkillCard = false;
  }

  /** ヘッダー画像などのsrcを取得 */
  private imgSrc(filePath: string) {
    const prefix = `accounts/${this.accountId}/account_images`;
    return `https://osha-p.com/${prefix}/${filePath}`;
  }

  private selectJob(jobName: string) {
    this.jobName = jobName;
  }

  private selectSkill(skillName: string) {
    this.skillName = skillName;
    this.selectedSkillName = skillName;
  }

  private selectQualification(qualificationName: string) {
    this.qualificationName = qualificationName;
    this.selectedQualificationName = qualificationName;
  }
  /** ヘッダー画像などのsrcを取得 */
  private getImageSrc() {
    return require(`../../../assets/${this.headerImage}`);
  }

  private displayEditIcon(isDisplayEditIcon: boolean) {
    this.isDisplayEditIcon = isDisplayEditIcon;
  }

  /** アカウント参画プロジェクト内のアカウント評価有無 */
  private isEmptyAccountEvaluation(): boolean {
    const account = this.account;
    if (account) {
      return [
        account.technicalSkills,
        account.communicationSkills,
        account.understandingSkills,
      ].includes(null);
    } else return true;
  }

  /** 選択されたスキルを追加 */
  private addRetentionSkill() {
    if (this.selectedSkillName && parseInt(this.skillYearsOfExperience, 10)) {
      const retentionSkill: AccountRetentionSkill = {
        skillCd: this.selectedSkillName,
        yearsOfExperience: parseInt(this.skillYearsOfExperience, 10),
        skillLevel: null,
      };
      this.retentionSkills.push(retentionSkill);
      this.selectedSkillName = '';
      this.skillYearsOfExperience = '';
    } else return;
  }

  /** 選択されたスキルを削除 */
  private removeRetentionSkill(skillCd: string) {
    const index = this.retentionSkills.findIndex((skill) => skill.skillCd === skillCd);
    this.retentionSkills.splice(index, 1);
  }

  /** 選択されたスキルを追加 */
  private addRetentionQualification() {
    if (this.selectedQualificationName && parseInt(this.qualificationScore, 10)) {
      const retentionQualification: AccountRetentionQualification = {
        qualificationCd: this.selectedQualificationName,
        qualificationScore: parseInt(this.qualificationScore, 10),
      };
      this.retentionQualifications.push(retentionQualification);
      this.selectedQualificationName = '';
      this.qualificationScore = '';
    } else return;
  }

  /** 選択されたスキルを削除 */
  private removeRetentionQualification(qualificationCd: string) {
    const index = this.retentionQualifications.findIndex((qualification) => {
      return qualification.qualificationCd === qualificationCd;
    });
    this.retentionQualifications.splice(index, 1);
  }

  /** メインのお仕事の値を取得 */
  private getMainWork() {
    if (this.remoteFlag) {
      this.mainWork = this.workType.remote;
    }
    if (this.onsiteFlag) {
      this.mainWork = this.workType.onsite;
    }
    return this.mainWork;
  }

  /** リモートフラグ・オンサイトフラグを更新 */
  private changeWorkFlag(work: string) {
    if (work === this.workType.remote) {
      this.remoteFlag = true;
      this.onsiteFlag = false;
    } else if (work === this.workType.onsite) {
      this.remoteFlag = false;
      this.onsiteFlag = true;
    } else {
      this.remoteFlag = null;
      this.onsiteFlag = null;
    }
    return;
  }

  /** スキル一括更新API実行 */
  private async updateAccountAllSkill() {
    const param: UpdateAccountRetentionSkillParam = {
      retentionSkills: this.retentionSkills,
    };
    await this.accountsRepository.updateAccountAllSkill(this.accountId, param);
    await vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId);
  }

  /** 資格一括更新API実行 */
  private async updateAccountAllQualification() {
    const param: UpdateAccountRetentionQualificationParam = {
      retentionQualifications: this.retentionQualifications,
    };
    await this.accountsRepository.updateAccountAllQualification(
      this.accountId,
      param
    );
    await vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId);
  }

  /** アカウント自己紹介更新API実行 */
  private async updateAccountSelfIntroduction() {
    const param: UpdateAccountSelfIntroductionParam = {
      selfIntroduction: this.selfIntroduction,
    };
    await this.accountsRepository.updateAccountSelfIntroduction(
      this.accountId,
      param
    );
    await vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId);
  }

  /** アカウント基本情報更新API実行 */
  private async updateAccountBasic() {
    const param: UpdateAccountBasicParam = {
      accountName: this.accountName,
      age: this.age ? parseInt(this.age, 10) : undefined,
      occupationCd: this.jobName,
      genderCd: this.gender,
      phoneNumber: this.phoneNumber,
      streetAddress: this.streetAddress,
      birthday: this.birthday,
      place: this.place,
    };
    const query: UpdateAccountBasicQuery = {
      'update-mode': 'part',
    };
    await this.accountsRepository.updateAccountBasic(
      this.accountId,
      param,
      query
    );
    await vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId);
  }

  /** アカウント希望参画条件更新API実行 */
  private async updateAccountParticipationCondition() {
    const param: UpdateAccountParticipationConditionParam = {
      desiredPayment: this.desiredPayment ? parseInt(this.desiredPayment, 10): undefined,
      desiredPaymentUnitCd: this.desiredPaymentUnit,
      scheduleUptime: this.scheduleUptime ? parseInt(this.scheduleUptime, 10): undefined,
      remoteFlag: this.remoteFlag,
      onsiteFlag: this.onsiteFlag,
      yearsOfExperience: this.yearsOfExperience ? parseInt(this.yearsOfExperience, 10): undefined,
      nearStation: this.nearStation,
      participationAvailableDate: this.participationAvailableDate,
      participationNowAvailable: this.participationNowAvailable,
    };
    const query: UpdateAccountParticipationConditionQuery = {
      'update-mode': 'part',
    };
    const accountQuery: FindOneAccountQuery = {
      'detail-flag': this.detailFlag,
    };
    await this.accountsRepository.updateAccountParticipationCondition(
      this.accountId,
      param,
      query
    );
    await vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId);
  }

  private get account(): Account | undefined {
    return vxm.theoryApi.accountsStore.getAccountDetail?.results;
  }

  private get accountId(): number {
    return vxm.theoryApi.authStore.getCurrentUserInfo!.results.accountId as number;
  }

  //職種セレクトボックスの処理
  private get selectedJobName() {
    const selectedJob = this.occupations.find(
      (occupation) => occupation.occupationName === this.jobName
    );
    return selectedJob ? `${selectedJob.occupationName}` : '';
  }
  private get filteredJobs() {
    return this.occupations.filter(
      (occupation) =>
        occupation.occupationName.indexOf(this.searchJobWord) !== -1
    );
  }

  private get filteredSkills() {
    return this.skills.filter((skill) => {
      return (
        skill.skillName.indexOf(this.searchSkillWord) !== -1 &&
        !this.retentionSkills.map((skill) => skill.skillCd).includes(skill.skillName)
      );
    });
  }

  private get filteredQualifications() {
    return this.qualifications.filter((qualification) => {
      return (
        qualification.qualificationName.indexOf(this.searchQualificationWord) !== -1 &&
        !this.retentionQualifications
          .map((qualifictaion) => {
            return qualifictaion.qualificationCd;
          })
          .includes(qualification.qualificationName)
      );
    });
  }

  @Emit('closeUpdateHeaderPhotoModal')
  private closeUpdateHeaderPhotoModal(): void {
    this.isOpenUpdateHeaderPhotoModal = false;
  }
}
